// PersonalTab.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import constantApi from "../../constantApi";

export default function PersonalTab({
  employee,
  setEmployee,
  userRole,
  goToNextTab = () => {},
}) {
  // console.log("-----------employee---", employee)
  const [personalData, setPersonalData] = useState({
    email: "",
    phone: "",
    bank: "",
    emergencyContact: "",
    emergencyPhone: "",
    permitNo: "",
    permitExpiry: "",
    address: "",
    distance: "",
    certificate: "",
    fieldOfStudy: "",
    legalName: "",
    birthday: "",
    birthPlace: "",
    gender: "",
    nationality: "",
    idNo: "",
    ssn: "",
    passport: "",
    maritalStatus: "",
    dependents: "",
  });

  //const [permitFile, setPermitFile] = useState(null);

  // Load personal data from employee object
  // Load personal data from employee object
  useEffect(() => {
    if (employee?.personal_details) {
      const data = employee.personal_details;
      setPersonalData(employee.personal_details);
    }
  }, [employee]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPersonalData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      if (!employee?.emp_id) {
        alert("❌ Employee ID missing. Please create employee first.");
        return;
      }

      // Prepare plain JSON payload
      const payload = {
        emp_id: employee.emp_id, // ✅ this will be parsed by backend
        ...personalData, // ✅ spread all personalData fields
      };

      console.log("🚀 Sending payload:", payload);

      const res = await axios.post(
        `${constantApi.baseUrl}/personal/create`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("✅ Personal details saved:", res.data);

      alert("✅ Personal info saved successfully!");
      if (typeof setEmployee === "function") {
        setEmployee((prev) => ({ ...prev, personal_details: res.data.data }));
      }
      goToNextTab();
    } catch (err) {
      console.error(
        "❌ Failed to save personal info:",
        err.response?.data || err.message
      );
      alert("❌ Failed to save personal info!");
    }
  };

  // 🧨 Add this inside PersonalTab.jsx, near other handlers
  const handleDelete1 = async () => {
    try {
      if (!employee?.emp_id) {
        alert("❌ Employee ID missing. Cannot delete.");
        return;
      }

      if (
        !window.confirm(
          "⚠️ Are you sure you want to delete this personal information?"
        )
      ) {
        return;
      }

      const res = await axios.delete(
        `${constantApi.baseUrl}/personal/delete/${employee.emp_id}`
      );

      console.log("✅ Personal details deleted:", res.data);
      alert("✅ Personal details deleted successfully.");

      // Clear the personal data from UI
      setPersonalData({
        email: "",
        phone: "",
        bank: "",
        emergencyContact: "",
        emergencyPhone: "",
        permitNo: "",
        permitExpiry: "",
        address: "",
        distance: "",
        certificate: "",
        fieldOfStudy: "",
        legalName: "",
        birthday: "",
        birthPlace: "",
        gender: "",
        nationality: "",
        idNo: "",
        ssn: "",
        passport: "",
        maritalStatus: "",
        dependents: "",
      });

      // Also clear in parent employee object
      // setEmployee((prev) => ({ ...prev, personal_details: null }));
    } catch (err) {
      console.error(
        "❌ Failed to delete personal info:",
        err.response?.data || err.message
      );
      alert("❌ Failed to delete personal info!");
    }
  };

  const handleDelete = async () => {
    if (!employee?.emp_id) return alert("❌ Employee ID missing.");

    if (
      !window.confirm(
        "⚠️ Are you sure you want to delete this personal information?"
      )
    )
      return;

    try {
      const res = await axios.delete(
        `${constantApi.baseUrl}/personal/delete/${employee.emp_id}`
      );
      console.log("✅ Personal details deleted:", res.data);
      alert("✅ Personal details deleted successfully.");

      // Clear UI data
      setPersonalData({
        email: "",
        phone: "",
        bank: "",
        emergencyContact: "",
        emergencyPhone: "",
        permitNo: "",
        permitExpiry: "",
        address: "",
        distance: "",
        certificate: "",
        fieldOfStudy: "",
        legalName: "",
        birthday: "",
        birthPlace: "",
        gender: "",
        nationality: "",
        idNo: "",
        ssn: "",
        passport: "",
        maritalStatus: "",
        dependents: "",
      });

      setEmployee((prev) => ({ ...prev, personal_details: null }));
    } catch (err) {
      console.error(
        "❌ Failed to delete personal info:",
        err.response?.data || err.message
      );
      // alert("❌ Failed to delete personal info!");
    }
  };

  return (
    <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-lg p-6 space-y-6">
      {/* Private Contact */}
      <section className="bg-gray-50 border rounded-xl p-6">
        <h4 className="text-blue-700 font-semibold text-sm uppercase border-b pb-2">
          Private Contact
        </h4>
        <div className="grid grid-cols-2 gap-4 mt-4">
          <input
            type="email"
            name="email"
            value={personalData.email}
            onChange={handleChange}
            placeholder="Email"
            className="border rounded px-3 py-2"
          />
          <input
            type="text"
            name="phone"
            value={personalData.phone}
            onChange={handleChange}
            placeholder="Phone"
            className="border rounded px-3 py-2"
          />
          <input
            type="text"
            name="bank"
            value={personalData.bank}
            onChange={handleChange}
            placeholder="Bank Account"
            className="border rounded px-3 py-2"
          />
        </div>
      </section>

      {/* Emergency Contact */}
      <section className="bg-gray-50 border rounded-xl p-6">
        <h4 className="text-blue-700 font-semibold text-sm uppercase border-b pb-2">
          Emergency Contact
        </h4>
        <div className="grid grid-cols-2 gap-4 mt-4">
          <input
            type="text"
            name="emergencyContact"
            value={personalData.emergencyContact}
            onChange={handleChange}
            placeholder="Contact"
            className="border rounded px-3 py-2"
          />
          <input
            type="text"
            name="emergencyPhone"
            value={personalData.emergencyPhone}
            onChange={handleChange}
            placeholder="Phone"
            className="border rounded px-3 py-2"
          />
        </div>
      </section>

      {/* Work Permit */}
      <section className="bg-gray-50 border rounded-xl p-6">
        <h4 className="text-blue-700 font-semibold text-sm uppercase border-b pb-2">
          Work Permit
        </h4>
        <div className="grid grid-cols-3 gap-4 mt-4">
          <input
            type="text"
            name="permitNo"
            value={personalData.permitNo}
            onChange={handleChange}
            placeholder="Permit No"
            className="border rounded px-3 py-2"
          />
          <input
            type="date"
            name="permitExpiry"
            value={personalData.permitExpiry}
            onChange={handleChange}
            className="border rounded px-3 py-2"
          />
          <input
            type="file"
            // onChange={handlePermitUpload}
            className="border rounded px-3 py-2"
          />
        </div>
      </section>

      {/* Location */}
      <section className="bg-gray-50 border rounded-xl p-6">
        <h4 className="text-blue-700 font-semibold text-sm uppercase border-b pb-2">
          Location
        </h4>
        <div className="grid grid-cols-2 gap-4 mt-4">
          <input
            type="text"
            name="address"
            value={personalData.address}
            onChange={handleChange}
            placeholder="Private Address"
            className="border rounded px-3 py-2"
          />
          <input
            type="number"
            name="distance"
            value={personalData.distance}
            onChange={handleChange}
            placeholder="Home-Work Distance"
            className="border rounded px-3 py-2"
          />
        </div>
      </section>

      {/* Education */}
      <section className="bg-gray-50 border rounded-xl p-6">
        <h4 className="text-blue-700 font-semibold text-sm uppercase border-b pb-2">
          Education
        </h4>
        <div className="grid grid-cols-2 gap-4 mt-4">
          <input
            type="text"
            name="certificate"
            value={personalData.certificate}
            onChange={handleChange}
            placeholder="Certificate Level"
            className="border rounded px-3 py-2"
          />
          <input
            type="text"
            name="fieldOfStudy"
            value={personalData.fieldOfStudy}
            onChange={handleChange}
            placeholder="Field of Study"
            className="border rounded px-3 py-2"
          />
        </div>
      </section>

      {/* Birth Information */}
      <section className="bg-gray-50 border rounded-xl p-6">
        <h4 className="text-blue-700 font-semibold text-sm uppercase border-b pb-2">
          Birth Information
        </h4>
        <div className="grid grid-cols-2 gap-4 mt-4">
          <input
            type="text"
            name="legalName"
            value={personalData.legalName}
            onChange={handleChange}
            placeholder="Legal Name"
            className="border rounded px-3 py-2"
          />
          <input
            type="date"
            name="birthday"
            value={personalData.birthday}
            onChange={handleChange}
            className="border rounded px-3 py-2"
          />
          <input
            type="text"
            name="birthPlace"
            value={personalData.birthPlace}
            onChange={handleChange}
            placeholder="Place of Birth"
            className="border rounded px-3 py-2"
          />
          <select
            name="gender"
            value={personalData.gender}
            onChange={handleChange}
            className="border rounded px-3 py-2"
          >
            <option value="">Select Gender</option>
            <option>Male</option>
            <option>Female</option>
            <option>Other</option>
          </select>
        </div>
      </section>

      {/* Citizenship */}
      <section className="bg-gray-50 border rounded-xl p-6">
        <h4 className="text-blue-700 font-semibold text-sm uppercase border-b pb-2">
          Citizenship
        </h4>
        <div className="grid grid-cols-2 gap-4 mt-4">
          <input
            type="text"
            name="nationality"
            value={personalData.nationality}
            onChange={handleChange}
            placeholder="Nationality"
            className="border rounded px-3 py-2"
          />
          <input
            type="text"
            name="idNo"
            value={personalData.idNo}
            onChange={handleChange}
            placeholder="Identification No"
            className="border rounded px-3 py-2"
          />
          <input
            type="text"
            name="ssn"
            value={personalData.ssn}
            onChange={handleChange}
            placeholder="SSN No"
            className="border rounded px-3 py-2"
          />
          <input
            type="text"
            name="passport"
            value={personalData.passport}
            onChange={handleChange}
            placeholder="Passport No"
            className="border rounded px-3 py-2"
          />
        </div>
      </section>

      {/* Family */}
      <section className="bg-gray-50 border rounded-xl p-6">
        <h4 className="text-blue-700 font-semibold text-sm uppercase border-b pb-2">
          Family
        </h4>
        <div className="grid grid-cols-2 gap-4 mt-4">
          <select
            name="maritalStatus"
            value={personalData.maritalStatus}
            onChange={handleChange}
            className="border rounded px-3 py-2"
          >
            <option value="">Select Marital Status</option>
            <option>Single</option>
            <option>Married</option>
            <option>Divorced</option>
            <option>Widowed</option>
          </select>
          <input
            type="number"
            name="dependents"
            value={personalData.dependents}
            onChange={handleChange}
            placeholder="Dependent Children"
            className="border rounded px-3 py-2"
          />
        </div>
      </section>

      {/* Save Button */}
      {/* Save and Delete Buttons */}
      {/* {(userRole === 1 || userRole === 5) && ( */}
      {userRole != 2 && (
        <div className="flex justify-end gap-4">
          <button
            onClick={handleDelete}
            className="px-8 py-2 bg-gradient-to-r from-red-600 to-pink-600 text-white font-semibold rounded-lg shadow-md hover:opacity-90"
          >
            🗑️ Delete
          </button>

          <button
            onClick={handleSave}
            className="px-8 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-lg shadow-md hover:opacity-90"
          >
            💾 Save & Next
          </button>
        </div>
      )}
    </div>
  );
}
